<template>
    <el-container>
        <el-header height="80"><v-header></v-header></el-header>
        <el-container>
            <el-aside width="200px">
                <v-menu></v-menu>
            </el-aside>
            <el-main><router-view></router-view></el-main>
        </el-container>
    </el-container>
</template>
<script>
import header from '@/components/header.vue'
import leftMenu from '@/components/leftMenu.vue'
export default {
	name: 'app',
	data() {
		return {
		}
	},
	components: {
		'v-header': header,
		'v-menu': leftMenu
	},
}
</script>

<style>
	.el-container{
		height: 100%;
	}
	.el-header {
		padding: 0!important;
		z-index: 1;
	}
	.el-aside {
		margin-top: 15px;
		background-color: #fff;
	}
	.el-main {
		height: 100%;
		padding: 15px 10px;
    }
    .el-tabs__header {
        margin: 0 0 10px;
    }
</style>